export const EVENTS = {
  APP_DATA: {
    REFRESH: 'appdata.refresh',
    REFRESHING: 'appdata.refreshing',
    REFRESH_ERROR: 'appdata.error',
    REFRESHED: 'appdata.refreshed',
    UPDATE_REQUIRED: 'appdata.UPDATE_REQUIRED',

    UPDATING: 'appdata.UPDATING',
    UPDATED: 'appdata.UPDATED',
    UPDATE_FAILED: 'appdata.UPDATE_FAILED',

    UPDATE: 'appdata.UPDATE',
    UPDATE_GENERAL: 'appdata.UPDATE_GENERAL',
    UPDATE_CONTACTS: 'appdata.UPDATE_CONTACTS',
    UPDATE_RATES: 'appdata.UPDATE_RATES',
    UPDATE_USSD: 'appdata.UPDATE_USSD',
    UPDATE_ADDRESSES: 'appdata.UPDATE_ADDRESSES',
    UPDATE_APPLINKS: 'appdata.UPDATE_APPLINKS',
    UPDATE_PAYMENT_PROVIDERS: 'appdata.UPDATE_PAYMENT_PROVIDERS',
    UPDATE_MANUAL_OPERATIONS: 'appdata.UPDATE_MANUAL_OPERATIONS'
  }
};
export const ENDPOINTS = {
  APP_DATA: {
    GET: '/store/app/data?service={lacasaeBettingServiceName}&userId={lacasaeBettingServiceName}&group=lacasae',
    UPDATE:
      '/store/app/data?service={lacasaeBettingServiceName}&userId={lacasaeBettingServiceName}&group=lacasae'
  }
};
